module.exports = "/dist/ljs/shared-ffa80cd1efc0704219f3e4094ce9736c.js";